import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ArrowLeftIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <rect style={{ fill: "none" }} width="24" height="24" transform="translate(24 24) rotate(-180)" />
            <polyline
                style={{
                    fill: "none",
                    stroke: "currentColor",
                    strokeMiterlimit: 10,
                    strokeWidth: "1.2px",
                    strokeLinecap: "square",
                }}
                points="11.25 20.99 3.25 11.99 11.5 2.99"
            />
            <line
                style={{
                    fill: "none",
                    stroke: "currentColor",
                    strokeMiterlimit: 10,
                    strokeWidth: "1.2px",
                    strokeLinecap: "square",
                }}
                x1="4.25"
                y1="11.99"
                x2="20.75"
                y2="11.99"
            />
        </SvgIcon>
    );
};
